export const trackEvents = {
  ADD_TO_CART: 'add_to_cart',
  ADD_TO_WISHLIST: 'add_to_wishlist',
  BEGIN_CHECKOUT: 'begin_checkout',
  CHECKOUT: 'checkout',
  DIY_SEARCH: 'diy_search',
  FIND_NEAREST_STORE: 'find_nearest_store',
  STORE_SELECTED: 'store_selected',
  FORM_SUBMITTED: 'form_submitted',
  KEYWORD_SEARCHED: 'keyword_searched',
  LINK_CLICKED: 'link_click',
  PAGE_VIEWED: 'page_view',
  POPUP_SHOWN: 'popup_shown',
  PURCHASE: 'purchase',
  SEARCH_RESULT_SELECTED: 'search_result_selected',
  SELECT_ITEM: 'select_item',
  VIEW_CART: 'view_cart',
  VIEW_ITEM: 'view_item',
  VIEW_LIST: 'view_item_list',
  WIZARD_INTERACTED: 'wizard_interacted',
  WIZARD_RESULT_VIEWED: 'wizard_result',
};
